export default __webpack_public_path__ + "static/media/hotel.6e306f18.png";